import { useQuery, keepPreviousData } from "@tanstack/react-query";
import type { SpyserpDateRangeParams } from "@/services/SpySerpService";
import { spySerpService } from "@/services/SpySerpService";
import { ensureSpyserpDateRange } from "@/hooks/spyserp/ensureSpyserpDateRange";

export const getSpyserpInsightsQueryKey = ({
  dateRange,
  customFrom,
  customTo,
}: SpyserpDateRangeParams) =>
  [
    "spyserp",
    "insights",
    dateRange,
    customFrom ?? null,
    customTo ?? null,
  ] as const;

export const useSpyserpInsights = (params: SpyserpDateRangeParams) =>
  useQuery({
    queryKey: getSpyserpInsightsQueryKey(params),
    queryFn: async () => {
      const resolved = await ensureSpyserpDateRange(params);
      return spySerpService.getInsights(resolved);
    },
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
  });
